export function stringToArray(value: string) {
  return value.split(/\r\n|\n\r|\n|\r/)
}
